import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserAdministrativeResponse } from 'src/app/models/advance-transfer.model';

@Component({
  selector: 'app-modal-user-administrative',
  templateUrl: './modal-user-administrative.component.html',
  styleUrls: ['./modal-user-administrative.component.scss']
})
export class ModalUserAdministrativeComponent {
  @Output() close = new EventEmitter<string>();
  @Input() users: UserAdministrativeResponse[] = [];
  @Input() companyName = "";
}
